import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const LaboratoryDetails = () => {
  const [labData, setLabData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    const fetchLaboratoryData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/laboratory/`
        );
        console.log("response", response);

        // Check if laboratoryList exists and has items
        if (
          response.data.laboratoryList &&
          response.data.laboratoryList.length > 0
        ) {
          // Determine which laboratory to display based on current URL
          let targetLabTitle = "";

          if (currentPath.includes("/department/cse")) {
            targetLabTitle = "CSE Laboratory";
          } else if (currentPath.includes("/department/mom")) {
            targetLabTitle = "MOM Laboratory";
          }

          // Find the appropriate laboratory in the array
          const lab = response.data.laboratoryList.find(
            (lab) => lab.title === targetLabTitle
          );

          if (lab) {
            setLabData(lab);
          } else {
            setError(`No ${targetLabTitle} data available.`);
          }
        } else {
          setError("No laboratory data available.");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching laboratory details:", error);
        setError("Failed to fetch laboratory details.");
        setLoading(false);
        toast.error("Failed to fetch laboratory details.");
      }
    };

    fetchLaboratoryData();
  }, [currentPath]);

  const openPdfInNewTab = () => {
    if (labData && labData.pdf) {
      // Construct full PDF URL if it's a relative path
      const pdfUrl = labData.pdf.startsWith("http")
        ? labData.pdf
        : `${process.env.REACT_APP_BASE_URL}/${labData.pdf.replace(
            /\\/g,
            "/"
          )}`;

      window.open(pdfUrl, "_blank");
    }
  };

  // Check if we should display anything on the current path
  const shouldDisplayLab = () => {
    if (!labData) return false;

    if (
      labData.title === "CSE Laboratory" &&
      currentPath.includes("/department/cse")
    ) {
      return true;
    }

    if (
      labData.title === "MOM Laboratory" &&
      currentPath.includes("/department/mom")
    ) {
      return true;
    }

    return false;
  };

  if (loading) {
    return (
      <div className="ml-4">
        <p>Loading laboratory details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ml-4">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  if (!shouldDisplayLab()) {
    return null; // Don't display anything if not in the right department
  }

  return (
    <div className="ml-4">
      <div className="flex items-center justify-between w-full">
        <span className="font-medium text-gray-800">{labData.title} PDF</span>
        <button
          onClick={openPdfInNewTab}
          className="px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600 transition-colors"
        >
          View PDF
        </button>
      </div>
    </div>
  );
};

export default LaboratoryDetails;
